import React from "react";

const RollKallInvoicingBenefits = () => {
	const { lang } = global;

	return (
		<div className="billed-electronically-benefits-containter">
			<div className="row">
				<div className="col-xs-12">
					<div className="row benefit-item">
						<div className="col-xs-1 text-center">
							<i className="rkf rkf-umbrella-cop font-size-20" />
						</div>
						<div className="col-xs-10">
							<p className="primary-text">
								{lang.t(
									"$11M of included General Liability coverage for LEA, Officer, and Client",
								)}
							</p>
						</div>
					</div>
					<div className="row benefit-item">
						<div className="col-xs-1 text-center">
							<i className="rkf rkf-shield-star-o font-size-20" />
						</div>
						<div className="col-xs-10">
							<p className="primary-text">
								{lang.t(
									"Access to InstantPay and Occupational Accident Insurance options for officers",
								)}
							</p>
						</div>
					</div>
					<div className="row benefit-item">
						<div className="col-xs-1 text-center">
							<i className="rkf rkf-dollar font-size-20" />
						</div>
						<div className="col-xs-10">
							<p className="primary-text">
								{lang.t(
									"Simplified invoice creation and secure online payment of invoices with automated reminders",
								)}
							</p>
						</div>
					</div>
					<div className="row benefit-item">
						<div className="col-xs-1 text-center">
							<i className="rkf rkf-note font-size-20" />
						</div>
						<div className="col-xs-10">
							<p className="primary-text">
								{lang.t(
									"Ability to charge for various fees and route payment to appropriate parties",
								)}
							</p>
						</div>
					</div>
					<div className="row benefit-item">
						<div className="col-xs-1 text-center">
							<i className="rkf rkf-analytics font-size-20" />
						</div>
						<div className="col-xs-10">
							<p className="primary-text">
								{lang.t(
									"Comprehensive financial reporting for compliance and auditing",
								)}
							</p>
						</div>
					</div>
					<div className="row benefit-item">
						<div className="col-xs-1 text-center">
							<i className="rkf rkf-police-office font-size-20" />
						</div>
						<div className="col-xs-10">
							<p className="primary-text">
								{lang.t(
									"Consolidated W9/1099 documentation and 1099-K distribution at year-end",
								)}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default RollKallInvoicingBenefits;
